<template>
    <div>
        <template v-if="displayMode === 1">
            <div class="accounting-statement-normal-table-wrapper">
                <NormalDisplay
                    :tableData="tableData"
                    :isLoading="isLoading"
                    :todayDateTxt="todayDateTxt"
                    :settlementDateTxt="settlementDateTxt"
                    :closedDateTxt="closedDateTxt"
                    :startDateTxt="startDateTxt"
                    :endDateTxt="endDateTxt"
                    :hideChildItems="hideChildItems"
                    @click="onClickItem"
                />
            </div>
        </template>
        <template v-else>
            <MonthlyDisplay
                :tableData="monthlyTableData"
                :isLoading="isLoading"
                :todayDateTxt="todayDateTxt"
                :settlementDateTxt="settlementDateTxt"
                :closedDateTxt="closedDateTxt"
                :startDateTxt="startDateTxt"
                :endDateTxt="endDateTxt"
                :hideChildItems="hideChildItems"
                :year="queryYear"
                @click="onClickItem"
            />
        </template>
    </div>
</template>

<script>
import NormalDisplay from './NormalDisplay.vue';
import MonthlyDisplay from './MonthlyDisplay.vue';

export default {
    components: {
        NormalDisplay,
        MonthlyDisplay,
    },
    props: {
        hideChildItems: Boolean,
        isLoading: Boolean,

        displayMode: {
            type: Number,
            default: 1, // 1: normal, 2: monthly
        },
        queryYear: {
            type: Number,
            default: 0,
        },

        startDateTxt: {
            type: String,
            default: '',
        },
        endDateTxt: {
            type: String,
            default: '',
        },

        monthlyTableData: {
            type: Array,
            default: () => [],
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        isStartEndDateSameYear: {
            type: Boolean,
            default: true,
        },
        todayDateTxt: {
            type: String,
            default: '',
        },
        settlementDateTxt: {
            type: String,
            default: '',
        },
        closedDateTxt: {
            type: String,
            default: '',
        },
    },
    methods: {
        onClickItem(item) {
            if (!item.level) return;

            this.$emit('click', item);
        },
    },
};
</script>
